'use strict';
angular.module('schoolLinqApp').directive('localUseFieldsSetup', localUseFieldSetupController);

function localUseFieldSetupController() {
	var controller = [
		'$scope',
		'$q',
		'$uibModal',
		'localUseService',
		function (scope, $q, $uibModal, localUseService) {
			scope.loadLocalUse = function () {
				scope.fields = [];
				scope.groups = [];
				scope.dirty = false;
				scope.errors = [];

				// scope.loadLocalUseFields();
				localUseService.getEntityFields(scope.entityType.value).subscribe(
					(response) => {
						if (response.isValid) {
							scope.fields = response.fields;
							// update any null group names to 'Misc.'
							_.forEach(scope.fields, function (field) {
								if (!field.GroupName) field.GroupName = 'Misc.';
							});
							scope.fieldsBackup = angular.copy(scope.fields);
							scope.groups = scope.getGroups();
						} else {
							scope.errors.push(response.error);
						}

						if (scope.mustReload === true) {
							scope.mustReload = false;
							scope.afterSave();
						}
					},
					(error) => {
						scope.errors = error;
					}
				);
			};

			scope.getGroups = function () {
				var groupNames = _.uniq(
					_.map(scope.fields, function (field) {
						return field.GroupName;
					})
				);

				var groups = [];
				_.forEach(groupNames, function (groupName) {
					var groupFields = scope.getGroupFields(groupName);
					groups.push({
						groupName: groupName,
						groupFields: groupFields,
						updatingName: false,
					});
				});

				return _.sortBy(groups, function (group) {
					return group.groupName.toLowerCase();
				});
			};

			scope.getGroupFields = function (groupName) {
				var groupFields = _.sortBy(
					_.filter(scope.fields, function (field) {
						return field.GroupName === groupName;
					}),
					'Priority'
				);
				return groupFields;
			};

			scope.dragStop = function (event, ui) {
				var movedItem = ui.item.scope().field;
				var groupName = movedItem.GroupName;
				var group = _.findWhere(scope.groups, { groupName: groupName });

				var priority = 0;
				_.forEach(group.groupFields, function (field) {
					priority++;
					if (field.Priority !== priority) {
						field.Priority = priority;
						field.IsDirty = true;
					}
				});
			};

			scope.addGroup = function () {
				var group = {
					groupName: 'new group',
					groupFields: [],
				};

				scope.addFieldToGroup(group);
				scope.groups.unshift(group);
				scope.editGroupName(group);
			};

			scope.addFieldToGroup = function (group) {
				var field = {
					Id: 0,
					EntityType: scope.entityType.value,
					GroupName: group.groupName,
					FieldName: 'new field',
					Active: true,
					Description: '',
					Priority: group.groupFields.length + 1,
					IsReferenced: false,
					IsDirty: true,
					IsDeleted: false,
				};
				scope.fields.push(field);
				group.groupFields.push(field);
			};

			scope.deleteField = function (field) {
				if (field.Id === 0) {
					var index = scope.fields.indexOf(field);
					if (index > -1) {
						scope.fields.splice(index, 1);
					}
				} else {
					field.IsDeleted = true;
					field.IsDirty = true;
				}
				// remove field from its parent group.groupFields array
				_.forEach(scope.groups, function (group) {
					var index = group.groupFields.indexOf(field);
					if (index > -1) {
						group.groupFields.splice(index, 1);
					}
				});
			};

			scope.sortAtoZ = function (group, reverse) {
				group.groupFields = _.sortBy(group.groupFields, function (item) {
					return item.FieldName.toLowerCase();
				});
				if (reverse === true) group.groupFields = group.groupFields.reverse();
				var priority = 0;
				_.forEach(group.groupFields, function (field) {
					priority++;
					if (field.Priority !== priority) {
						field.Priority = priority;
						field.IsDirty = true;
					}
				});
			};

			scope.editGroupName = function (group) {
				group.oldName = group.groupName;
				group.updatingName = true;
			};

			scope.cancelGroupNameEdit = function (group) {
				group.groupName = group.oldName;
				group.updatingName = false;
			};

			scope.finishGroupNameEdit = function (group) {
				if (!group.groupName) return;
				if (group.updatingName !== true) return;

				group.updatingName = false;
				if (group.oldName === group.groupName) return;

				_.forEach(group.groupFields, function (field) {
					field.GroupName = group.groupName;
					field.IsDirty = true;
				});

				group.oldName = group.groupName;
			};

			scope.isDirty = function () {
				scope.dirty = _.some(scope.fields, function (field) {
					return field.IsDirty;
				});
				return scope.dirty;
			};

			scope.save = function () {
				// complete any pending group name edits (user didn't click accept or cancel)
				_.forEach(scope.groups, function (group) {
					scope.finishGroupNameEdit(group);
				});

				scope.errors = [];
				var promises = [];

				_.forEach(scope.fields, function (field) {
					if (field.IsDeleted === true) {
						promises.push(
							new Promise((resolve, reject) => {
								localUseService.deleteField(field.Id).subscribe(
									(response) => {
										if (response.isValid && response.result === true) {
											const itemToDelete = scope.fields.find((f) => f.Id === field.Id);
											if (itemToDelete) {
												scope.fields = scope.fields.filter((f) => f.Id !== itemToDelete.Id);
											}
										} else {
											scope.errors.push(field.FieldName + ' error: ' + response.error);
										}
										resolve();
									},
									(error) => {
										scope.errors = error;
										reject();
									}
								);
							})
						);
					} else if (field.IsDirty === true) {
						promises.push(
							new Promise((resolve, reject) => {
								localUseService.postField(field).subscribe(
									(response) => {
										if (response.isValid) {
											field.Id = response.field.Id;
											field.IsDirty = false;
										} else {
											scope.errors.push(field.FieldName + ' error: ' + response.error);
										}
										resolve();
									},
									(error) => {
										scope.errors = error;
										reject();
									}
								);
							})
						);
					}
				});

				if (promises.length) {
					$q.all(promises)
						.then(function () {
							if (scope.errors.length === 0) {
								scope.fieldsBackup = angular.copy(scope.fields);
								scope.groups = scope.getGroups();
								scope.afterSave();
							} else scope.mustReload = true;
						})
						.catch(() => (scope.mustReload = true));
				}
			};

			scope.cancelChanges = function () {
				scope.fields = angular.copy(scope.fieldsBackup);
				scope.groups = scope.getGroups();
				scope.errors = [];
				scope.afterCancel();
			};

			scope.onEntityTypeChange = function (prev) {
				if (scope.dirty) {
					$uibModal
						.open({
							template: require('@ajs/templates/exit-dialog.tpl.html'),
							backdrop: 'static',
							keyboard: false,
							controller: [
								'$scope',
								'$uibModalInstance',
								function ($scope, modalInstance) {
									$scope.actionWord = 'Change';
									angular.extend($scope, {
										cancel: function () {
											modalInstance.close();
										},
										exit: function () {
											modalInstance.close('reset');
										},
									});
								},
							],
						})
						.result.then(function (reset) {
							if (reset) {
								scope.loadLocalUse();
							} else {
								scope.entityType = JSON.parse(prev);
							}
						});
				} else {
					scope.loadLocalUse();
				}
			};

			scope.editValuesList = function (field, readonly) {
				$uibModal.open({
					template: require('@ajs/templates/localUseFieldsSetup-valuelist-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						function (scope, modalInstance) {
							scope.field = field;
							scope.readonly = readonly;
							scope.values = [];
							_.each(field.ListOfValues, function (value) {
								scope.values.push({ orig: value, current: value }); // need to create object array for ngModel two-way binding to work
							});

							if (scope.readonly === true) {
								scope.sortableOptions = {
									disabled: true,
								};
							} else {
								scope.sortableOptions = {
									cursor: 'move',
									delay: 200,
									forcePlaceholderSize: true,
									opacity: 0.8,
									placeholder: 'ui-sortable-placeholder',
									revert: true,
									stop: function (event, ui) {
										scope.valuesForm.$setDirty();
									},
								};
							}

							scope.addValue = function () {
								scope.values.unshift({ orig: '', current: '' });
								scope.valuesForm.$setDirty();
							};

							scope.saveValues = function () {
								if (!scope.readonly) {
									if (!scope.valuesForm.$valid) return false;

									if (scope.valuesForm.$dirty) {
										scope.field.ListOfValues = _.map(scope.values, function (value) {
											return value.current;
										});
										scope.field.IsDirty = true;
									}
								}

								modalInstance.close();
							};

							scope.cancelValues = function () {
								modalInstance.close();
							};

							scope.deleteValue = function (item) {
								var index = scope.values.indexOf(item);
								if (index > -1) {
									scope.values.splice(index, 1);
									scope.valuesForm.$setDirty();
								}
							};

							scope.clearAllValues = function () {
								if (scope.values && scope.values.length !== 0) {
									scope.values = [];
									scope.valuesForm.$setDirty();
								}
							};

							scope.sortAtoZ = function (reverse) {
								scope.values = _.sortBy(scope.values, function (item) {
									return item.current.toLowerCase();
								});
								if (reverse === true) scope.values = scope.values.reverse();
								scope.valuesForm.$setDirty();
							};
						},
					],
				});
			};
		},
	];

	return {
		restrict: 'E',
		scope: {
			entityTypes: '=', // types of entity
			okToLoad: '=', // flag to enable/disable loading of data
			readonly: '=', // flag indicating read-only status
			dirty: '=', // let's consumer know if the directive has unsaved changes
			doCancel: '=', // allows consumer to trigger the directive's cancelChanges() function
			afterSave: '&', // reference to function to run after successful save operation
			afterCancel: '&', // reference to function to run after cancel operation,
		},
		replace: true,
		template: require('@ajs/templates/localUseFieldsSetup.html'),
		controller: controller,
		link: function (scope, element, attrs) {
			scope.entityType = { name: 'Employee', value: 'PR_Employee' };
			scope.$watch('okToLoad', function (value) {
				if (value === true) scope.loadLocalUse();
			});

			scope.$watch('doCancel', function (value) {
				if (value === true) {
					scope.doCancel = false;
					scope.cancelChanges();
				}
			});

			if (scope.readonly === true) {
				scope.sortableOptions = {
					disabled: true,
				};
			} else {
				scope.sortableOptions = {
					cursor: 'move',
					delay: 200,
					forcePlaceholderSize: true,
					opacity: 0.8,
					placeholder: 'ui-sortable-placeholder',
					revert: true,
					stop: function (event, ui) {
						scope.dragStop(event, ui);
					},
				};
			}
		},
	};
}
